// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Q7Qx","requiredAsterisk":"Info_requiredAsterisk__BFVDh"};